import axios from "axios";

export default axios.create({
  baseURL: "https://tke-travel.onrender.com/api/v1",
  // baseURL: "https://tke-travel.onrender.com/api/v1",
});
// https://tek-travel.herokuapp.com/api/v1/questionnaires/create
// /user/login
